import { LinkItem } from '@app/shared/interfaces';

export const communityLinks: LinkItem[] = [
  { id: 'privacy', label: 'Privacy Policy', url: 'https://maji.la/privacy' },
  {
    id: 'terms',
    label: 'Terms and conditions',
    url: 'https://maji.la/terms',
  },
];
